import React, { useState } from "react";
import { Download, Maximize2, FileDown } from "lucide-react";
import { useLang } from "@/lib/lang";

const L = {
  en: { page: (a, b) => `Page ${a} of ${b}`, view: "View full size", dl: "Download Page", all: "Download All Pages (PDF)" },
  es: { page: (a, b) => `Página ${a} de ${b}`, view: "Ver en grande", dl: "Descargar página", all: "Descargar todas las páginas (PDF)" },
};
const useL = () => L[useLang().lang];
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const SheetCard = ({ s, i, total, onView }) => {
  const l = useL();
  return (
  <div className="bg-white rounded-2xl p-5 card-tactile flex flex-col" data-testid={`sample-sheet-${s.id}`}>
    <p className="eyebrow mb-2">{l.page(i + 1, total)}</p>
    <button onClick={() => onView(s)} className="rounded-lg overflow-hidden border border-bsn-gold/30 bg-white w-full aspect-[1103/1426] relative" data-testid={`sample-view-${s.id}`} aria-label={`View ${s.title} full size`}>
      <img src={s.img} alt={`${s.title} sample`} loading="lazy" className="w-full h-full object-contain" />
      <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 bg-bsn-midnight/85 text-bsn-parchment text-xs px-2.5 py-1 rounded-full">
        <Maximize2 className="w-3 h-3" /> {l.view}
      </span>
    </button>
    <h4 className="font-serif text-lg font-semibold text-bsn-midnight mt-4">{s.title}</h4>
    <a href={s.pdf} download className="mt-3 self-start inline-flex items-center gap-2 px-5 py-2.5 rounded-full btn-gold font-semibold text-sm" data-testid={`sample-download-${s.id}`}>
      <Download className="w-4 h-4" /> {l.dl}
    </a>
  </div>
);
};

export const PrintableSamples = ({ groups }) => {
  const l = useL();
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-14" data-testid="printable-samples">
      {groups.map((g) => (
        <div key={g.id} data-testid={`sample-group-${g.id}`}>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
            <div>
              <h4 className="font-serif text-2xl font-semibold text-bsn-midnight">{g.title}</h4>
              <p className="text-sm text-bsn-sapphire/75 mt-1">{g.desc}</p>
            </div>
            {g.sheets.length > 1 && <a href={g.pdf} download className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-bsn-midnight text-bsn-parchment font-semibold text-sm shrink-0" data-testid={`sample-download-all-${g.id}`}>
              <FileDown className="w-4 h-4" /> {l.all}
            </a>}
          </div>
          <div className="grid sm:grid-cols-2 gap-8 max-w-4xl">
            {g.sheets.map((s, i) => <SheetCard key={s.id} s={s} i={i} total={g.sheets.length} onView={setOpen} />)}
          </div>
        </div>
      ))}

      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto bg-white" data-testid="sample-dialog">
          <DialogTitle className="font-serif text-bsn-midnight">{open?.title}</DialogTitle>
          {open && <img src={open.img} alt={`${open.title} full size`} className="w-full h-auto rounded-lg" />}
          {open && (
            <a href={open.pdf} download className="self-start inline-flex items-center gap-2 px-5 py-2.5 rounded-full btn-gold font-semibold text-sm" data-testid="sample-dialog-download">
              <Download className="w-4 h-4" /> {l.dl}
            </a>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
